import React, { useEffect } from 'react';
import Loading from '../../components/Loading';
import { Redirect } from '@reach/router';
import { useJsonApi } from '../../services/GlobalStore/GlobalStore';
import { translateRoute } from '../../utils/routes';

// translations
import routes from '../../messages/routes';

export const getIdFromNumber = (number: string): string =>
  number?.slice(-6).replace(/^0+/, '');

const Claim = ({
  claimNumber,
  children,
  redirect = true,
}: {
  claimNumber?: string;
  children?: JSX.Element;
  redirect?: boolean;
}): any => {
  const claimId = claimNumber && getIdFromNumber(claimNumber);

  const { data, loading } = useJsonApi(
    claimId ? `/claims/${claimId}` : `/claims`,
    {
      cachePolicy: 'no-cache',
      queryParams: {
        include: [
          'passengers',
          'passengers.person',
          'customer',
          'organizations',
          'placeOfJurisdiction',
          'customerFlights.airline',
          'customerFlights.departureAirport',
          'customerFlights.departureAirport.city',
          'customerFlights.arrivalAirport',
          'customerFlights.arrivalAirport.city',
        ].join(),
      },
    },
    []
  );

  useEffect(() => {
    if (data && claimNumber) {
      localStorage.setItem('yo:claimId', getIdFromNumber(claimNumber));
    }
    // eslint-disable-next-line
  }, [loading]);

  if (redirect && !loading && !claimNumber && data) {
    const path = ['/', translateRoute(routes.claim), data[0].claim_number].join(
      '/'
    );
    return <Redirect to={path} noThrow={true} />;
  }

  if (loading) {
    return (
      <div className="flex justify-center mt-40">
        <Loading />
      </div>
    );
  }

  if (data) return children;

  return null;
};

export default Claim;
